import React from 'react'
import { PlusIcon } from "@heroicons/react/24/outline";

export default function EmptyRulesets({ discountId, createDiscount, setUiState }) {
  return (
    <div className="mt-3">
      <hr/>

      <h3 className="my-2">No Rulesets for this Discount Policy.</h3>
      <button
        type="button"
        className="inline-flex items-center justify-center border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 rounded px-2 py-1 text-xs font-medium shadow-sm transition"
        onClick={(e) => {
          e.preventDefault();
          if(!discountId) {
            createDiscount()
              .then(() => {
                setUiState("new")
              })
              .catch(() => {})
          } else {
            setUiState("new")
          }
        }}
      >
        <PlusIcon className="w-4 h-4 mr-1" />
        Create First Ruleset
      </button>
    </div>
  )
}
